export default function(data) {
var __t, __p = '';
__p += '\n<span class="label label-' +
((__t = ( data.milestone )) == null ? '' : __t) +
' js-Milestone">\n  ' +
((__t = ( data.milestone )) == null ? '' : __t) +
'\n</span>\n\n';
return __p
}